module.exports = __webpack_public_path__ + "media/images/digivent/digivent_black-4c359ec44f70d5c00aaece2881c5d9e2.png";